import { defineMessages } from 'react-intl';

export const scope = 'app.components.side_navigation';

export default defineMessages({
  logo_alt: {
    id: `${scope}.logo_alt`,
    defaultMessage: 'LOGO',
  },
});
